import API from "../utils/api";
import { apiRequest } from "../utils/goddiva_api";

export const getSellerReportDataApi = async (data) => {
  const response = await API.get('report/sales-report',{
      params: data,
  });
  return {response};
};

export const getBackInStockReportApi = async (data) => {
    const response = await API.get('report/back-in-stock-report',
        {
            params: data,
        });
    return {response};
}

export const getSelectedBackInRequestData = async (id) => {
    const response = await API.get(`report/get-selected-back-in-stock/${id}`);
    return {response};
};

export const getExchangeOrderReportApi = async (data) => {
    const response = await API.get(`order/get-all-exchange-orders`, {params:data});
    return {response};
}

export const offerItemReportApi = async (data) => {
    const response = await API.get('report/offer-report', {params:data});
    return {response};
}

export async function goddivaInvoiceReportApi(filters) {

    const response = await apiRequest({
        url: "/report/goddiva/purchase-invoices",
        method: "GET",
        params: filters
    });

    return response.data;
}

export async function goddivaInvoiceByIdApi(data) {
    const { invoiceId, ...params } = data;
    const response = await apiRequest({
        url: "/report/goddiva/purchase-invoices/"+invoiceId,
        method: "GET",
        params: params
    });

    return response.data;
}


export async function exportInvoiceRowApi(invoiceId) {

    const response = await apiRequest({
        url: `/report/goddiva/purchase-invoices/export/${invoiceId}`,
        method: "GET",
        // responseType: "blob"
    });

    return {response};
}

export async function uploadInvoiceToXeroApi(invoiceId) {

    const response = await apiRequest({
        url: `/report/goddiva/purchase-invoices/upload-to-xero/${invoiceId}`,
        method: "POST",
        // responseType: "blob"
    });

    return {response};
}